import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import {
    CreateInstallerAccessGrantModel,
    InstallerAccessGrantDto,
    UpdateInstallerAccessGrantModel,
} from './models/InstallerAccessGrantDto';
import { InstallerAccessGrantsSearchCriteria } from './models/InstallerAccessGrantsSearchCriteria';

class InstallerAccessesService {
    public getList(criteria: InstallerAccessGrantsSearchCriteria) {
        return Http.get<Paged<InstallerAccessGrantDto>>('installeraccesses', criteria);
    }

    public getById(id: string) {
        return Http.get<InstallerAccessGrantDto>('installeraccesses/' + id);
    }

    public create(model: CreateInstallerAccessGrantModel) {
        return Http.post<string>('installeraccesses', model);
    }

    public update(model: UpdateInstallerAccessGrantModel) {
        return Http.put('installeraccesses', model);
    }

    public remove(model: InstallerAccessGrantDto) {
        return Http.put('installeraccesses/deactivate', model);
    }
}

export default new InstallerAccessesService();
